export default __webpack_public_path__ + "static/media/Capture.bdd37601.PNG";